import {
  attributeSlugOfParam,
  isFilterSelected,
  parseFilterParams,
  setFlagParam,
  setPriceBand,
  setAttributeNumberBand,
  toggleFilterValue,
} from "~/lib/storefront/filter-params";
import type { FacetHandlers } from "./facet-groups";

/**
 * P2-11 · Build the facet handler bag from a query string + an `apply`
 * callback. Live mode passes `router.push`; the mobile drawer passes its
 * staged-state setter — same controls, two destinations.
 */
export function createFilterHandlers(
  search: string,
  apply: (nextSearch: string) => void,
  currency: string,
): FacetHandlers {
  const filters = parseFilterParams(new URLSearchParams(search));
  return {
    isSelected: (param, value) => isFilterSelected(filters, param, value),
    toggle: (param, value) => {
      apply(toggleFilterValue(search, param, value));
    },
    setFlag: (param, on) => {
      apply(setFlagParam(search, param, on));
    },
    setPrice: (lo, hi) => {
      apply(setPriceBand(search, lo, hi));
    },
    setAttributeRange: (param, lo, hi) => {
      apply(setAttributeNumberBand(search, param, lo, hi));
    },
    attributeRange: (param) => {
      const slug = attributeSlugOfParam(param) ?? "";
      const range = filters.attributes?.find((attribute) => attribute.slug === slug);
      return { lo: range?.minNumber, hi: range?.maxNumber };
    },
    price: {
      loMajor:
        filters.priceMinMinor !== undefined
          ? filters.priceMinMinor / 100
          : undefined,
      hiMajor:
        filters.priceMaxMinor !== undefined
          ? filters.priceMaxMinor / 100
          : undefined,
    },
    currency,
  };
}
